import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionId: null,
  currentStep: 0,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSessionId(state, action) {
      state.sessionId = action.payload;
    },
    setCurrentStep(state, action) {
      state.currentStep = action.payload;
    },
    resetAppState() {
      return initialState;
    }
  }
});

export const { setSessionId, setCurrentStep, resetAppState } = appSlice.actions;
export default appSlice.reducer;


